export const incByfiveoo={type:"incrementbyf",payload:1000}
export const decByfiveoo={type:"deccrementbyf",payload:1000}

export const incBytwo={type:"incrementbyt",payload:2000}
export const decBytwo={type:"deccrementbyt",payload:2000}
